import React from 'react';

const WhyUs: React.FC = () => {
  return (
    <section className="mx-auto px-4 md:px-10 lg:px-32 w-full bg-[#192842] pt-20 pb-20">
      <div className="">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          {/* Text Content - Left Side */}
          <div className="space-y-8">
            <h2 className="text-[25px] md:text-[40px] lg:text-[40px] font-[700] leading-[40px] text-[#fff] mb-7 lg:text-left">
            Why Choose Us?
            </h2>
            <p className="text-[16px] lg:text-[24px] md:text-[18px] text-[#fff] leading-[29px] font-[400] mb-4 last:mb-0">
            Junior mining demands precision. The Wealthy Miner leverages Rob’s 20-year track record to mitigate risks and seize opportunities, offering a mining community where research-driven success thrives. Begin your journey to mastery in junior mining investment today. Disclaimer: Junior mining involves significant risks. The Wealthy Miner provides research and ideas, not financial advice. Conduct your own due diligence.</p>
            <a href="https://the-wealthy-miner.mn.co/" target="_blank" rel="noopener noreferrer" className="inline-block w-full sm:w-auto bg-transparent border-2 border-white text-[#fff] lg:px-20 py-2.5 rounded-lg font-semibold text-lg hover:bg-white hover:text-[#1A2A44] transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 text-center">
            GET INCLUSIVE INSIGHTS
                        </a>
          </div>

          {/* Phone Mockups - Right Side */}
          <div className="flex justify-center lg:justify-end">
            <img 
              src="/images/phones.webp" 
              alt="Three overlapping phone mockups showing The Wealthy Miner app content" 
              className="w-full max-w-4xl h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
